module.exports = __webpack_public_path__ + "media/banners/paliwa-menu-1b140e47.svg";